import { Pencil1Icon, PlusCircledIcon, TrashIcon } from "@radix-ui/react-icons";
import { Button } from "../../components/ui/button";
import React, { useState } from "react";
import PinDashboardDialog from "../../components/Pin/PinDashboard/PinDashboardDialog";
import {
  createDashboardSectionAPI,
  deleteDashboardAPI,
  fetchDashboardAPI,
  fetchDashboardsAPI,
  updateDashboardLabelAPI,
} from "../../api/dashboardApi";
import AlertOverlay from "./AlertOverlay";
import { useNavigate } from "react-router-dom";

const DashboardHeader = ({
  setDashboard,
  dashboardId,
  dashboardLabel,
  setIsDashboardLoading,
  setDashboards,
}) => {
  const [dashboardValue, setDashboardValue] = useState(dashboardLabel);
  const [isDashboardDialogOpen, setIsDashboardDialogOpen] = useState(false);
  const [isNewSectionDialogOpen, setIsNewSectionDialogOpen] = useState(false);
  const [isAlertOverlayOpen, setIsAlertOverlayOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [sectionValue, setSectionValue] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async () => {
    await updateDashboardLabelAPI({
      setIsLoading,
      dashboardId,
      label: dashboardValue,
    });
    const data = await fetchDashboardAPI({ dashboardId, setIsLoading });
    setDashboard(data);
    setIsDashboardDialogOpen(false);
  };

  const handleCreateSection = async () => {
    await createDashboardSectionAPI({
      setIsLoading,
      dashboardId,
      label: sectionValue,
    });

    const data = await fetchDashboardAPI({ dashboardId, setIsLoading });
    setDashboard(data);
    setIsNewSectionDialogOpen(false);
    setSectionValue("");
  };

  const handleDashboardDelete = async () => {
    await deleteDashboardAPI({ setIsLoading, dashboardId });
    setIsNewSectionDialogOpen(false);

    const activeBrand = localStorage.getItem("activeBrand");
    const data = await fetchDashboardsAPI({
      setIsLoading: setIsDashboardLoading,
      activeBrand,
    });
    setDashboards(data);
    navigate("/");
  };
  return (
    <div className="flex justify-between items-center py-3 px-1 border-b border-zinc-700 bg-zinc-900 sticky top-0 left-0 z-10">
      <h2 className="capitalize">{dashboardLabel}</h2>
      <div className="flex gap-2 divide-x divide-zinc-700">
        <div>
          <PinDashboardDialog
            value={dashboardValue}
            title="Edit Dashboard"
            description="Enter a dashboard label name"
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            isDialogOpen={isDashboardDialogOpen}
            setIsDialogOpen={setIsDashboardDialogOpen}
            actionButtonName="Update Label"
            onChange={(e) => setDashboardValue(e.target.value)}
          >
            <Button
              size="icon"
              className="hover:bg-zinc-700 rounded-full shadow-none"
            >
              <Pencil1Icon className="text-zinc-400" />
            </Button>
          </PinDashboardDialog>

          <AlertOverlay
            isAlertOverlayOpen={isAlertOverlayOpen}
            setIsAlertOverlayOpen={setIsAlertOverlayOpen}
            isLoading={isLoading}
            handleContinue={handleDashboardDelete}
            title={`Are you sure you want to delete the ${dashboardLabel}?`}
            description="This action will permanently delete all sections within the dashboard and cannot be undone."
          >
            <Button
              size="icon"
              className="hover:bg-zinc-700 rounded-full shadow-none"
            >
              <TrashIcon className="text-zinc-400" />
            </Button>
          </AlertOverlay>
        </div>

        <div className="">
          <PinDashboardDialog
            value={sectionValue}
            title="New Section"
            description="Enter a unique name for your new section"
            handleSubmit={handleCreateSection}
            isLoading={isLoading}
            isDialogOpen={isNewSectionDialogOpen}
            setIsDialogOpen={setIsNewSectionDialogOpen}
            onChange={(e) => setSectionValue(e.target.value)}
          >
            <Button
              onClick={() => setSectionValue("")}
              size="sm"
              className="flex gap-1 ml-2 bg-indigo-600 hover:bg-indigo-500 shadow-none"
            >
              <PlusCircledIcon />
              New Section
            </Button>
          </PinDashboardDialog>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
